import React from "react";
import styles from './LocationAirport.module.scss'
import {IAirport} from 'data/interfaces/products';

export interface ILocationTimeProps {
  originAirport: IAirport;
  destinationAirport: IAirport;
  flip?: boolean;

  className?: string;

}

const LocationAirport = (props: ILocationTimeProps) => (
  <small
    className={`${styles.LocationAirport} ${props.className}`.trim()}
    title={(props.flip ? props.originAirport : props.destinationAirport).city}
  >{(props.flip ? props.originAirport : props.destinationAirport).iata}</small>
);

LocationAirport.defaultProps = {
  className: ''
};

export default LocationAirport;
